<div class="wrapper wrapper-full-page">
  <div class="page-header not-found-page header-filter"
       style="background-image: url('./assets/img/not-found-page/truck_not_found.gif');
              background-repeat: no-repeat; background-attachment: fixed; background-position: center;">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <h2 class="text-center color-white">
            {{'NOT_FOUND.TEXT' | translate}}
          </h2>
        </div>
      </div>
      <div class="row">
        <div class="ml-auto mr-auto">
          <a mat-raised-button class="btn btn-primary btn-lg" href="#">{{'NOT_FOUND.GO_TO_DASHBOARD' | translate}}</a>
        </div>
      </div>
    </div>
    <app-complete-pages-footer [breakAbsolutePosition]="false"></app-complete-pages-footer>
  </div>
</div>

